import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { PageLoadingService } from '../services/page-loading.service';

/**
 * Counts HTTP requests that start while a page transition is active.
 * The PageLoadingService stays on until all these requests complete.
 */
@Injectable()
export class PageLoadingInterceptor implements HttpInterceptor {
  private pageLoading = inject(PageLoadingService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.pageLoading.isActive) {
      return next.handle(req);
    }

    this.pageLoading.requestStarted();
    return next.handle(req).pipe(
      finalize(() => this.pageLoading.requestCompleted())
    );
  }
}
